export default __webpack_public_path__ + "static/lower_mainland.9ab0ede81428b8af4a1424a4557510f8.png";